import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import SEO from '@/components/common/SEO';
import { FileText } from 'lucide-react';

export default function Terms() {
  const { i18n } = useTranslation();
  const isKorean = i18n.language === 'ko';

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 max-w-4xl mx-auto">
      <SEO title="Terms of Service" description="The terms governing your use of KoreanHub." path="/terms" />
      {/* Header */}
      <div className="flex items-center gap-4 mb-8">
        <div className="w-14 h-14 bg-coral-100 dark:bg-coral-900/30 rounded-xl flex items-center justify-center">
          <FileText className="w-7 h-7 text-coral-600" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            {isKorean ? '이용약관' : 'Terms of Service'}
          </h1>
          <p className="text-gray-500 dark:text-gray-400">
            {isKorean ? '최종 업데이트: 2026년 2월 1일' : 'Last updated: February 1, 2026'}
          </p>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-800 rounded-2xl p-6 sm:p-8 shadow-lg prose dark:prose-invert max-w-none">
        {isKorean ? (
          <>
            <h2>1. 약관 동의</h2>
            <p>
              KoreanHub.net("서비스")에 접속하거나 이용함으로써 귀하는 본 이용약관에 동의하게 됩니다. 본 약관에 동의하지 않는 경우 서비스를 이용할 수 없습니다.
            </p>

            <h2>2. 서비스 설명</h2>
            <p>
              KoreanHub는 해외 거주 한인들을 위한 커뮤니티 플랫폼으로, 다음 서비스를 제공합니다:
            </p>
            <ul>
              <li>커뮤니티 게시판 및 토론</li>
              <li>한인 업소 정보</li>
              <li>숙소 예약 서비스</li>
              <li>이민 및 비자 정보</li>
              <li>이벤트 및 딜 정보</li>
            </ul>

            <h2>3. 계정 등록</h2>
            <p>서비스 이용을 위해 계정을 생성해야 할 수 있습니다. 귀하는:</p>
            <ul>
              <li>정확한 정보를 제공해야 합니다</li>
              <li>계정 보안을 유지할 책임이 있습니다</li>
              <li>계정에서 발생하는 모든 활동에 책임을 집니다</li>
              <li>보안 침해 시 즉시 당사에 알려야 합니다</li>
            </ul>

            <h2>4. 사용자 콘텐츠</h2>
            <p>귀하가 게시하는 콘텐츠에 대해:</p>
            <ul>
              <li>귀하가 해당 콘텐츠의 소유권을 보유합니다</li>
              <li>당사에 콘텐츠 사용, 표시, 배포 라이선스를 부여합니다</li>
              <li>콘텐츠가 타인의 권리를 침해하지 않음을 보증합니다</li>
              <li>당사는 부적절한 콘텐츠를 삭제할 권리를 보유합니다</li>
            </ul>

            <h2>5. 금지 행위</h2>
            <p>다음 행위는 금지됩니다:</p>
            <ul>
              <li>불법적이거나 유해한 콘텐츠 게시</li>
              <li>타인을 괴롭히거나 위협하는 행위</li>
              <li>스팸 또는 상업적 광고</li>
              <li>타인의 계정 무단 사용</li>
              <li>서비스 보안 침해 시도</li>
              <li>지적재산권 침해</li>
              <li>허위 정보 유포</li>
            </ul>

            <h2>6. 숙소 예약</h2>
            <p>숙소 예약 서비스 이용 시:</p>
            <ul>
              <li>당사는 호스트와 게스트를 연결하는 플랫폼입니다</li>
              <li>숙소 상태 및 정확성은 호스트의 책임입니다</li>
              <li>결제는 안전하게 처리되며 취소 정책이 적용됩니다</li>
              <li>분쟁 발생 시 당사가 중재할 수 있습니다</li>
            </ul>

            <h2>7. 결제 및 환불</h2>
            <ul>
              <li>모든 결제는 표시된 통화로 처리됩니다</li>
              <li>환불은 각 서비스의 취소 정책에 따릅니다</li>
              <li>당사는 사기 거래를 취소할 권리를 보유합니다</li>
            </ul>

            <h2>8. 지적재산권</h2>
            <p>
              서비스의 모든 콘텐츠, 기능, 디자인은 당사의 재산이며 저작권법으로 보호됩니다. 명시적 허가 없이 복제하거나 배포할 수 없습니다.
            </p>

            <h2>9. 면책 조항</h2>
            <p>
              서비스는 "있는 그대로" 제공됩니다. 당사는 서비스의 정확성, 완전성, 신뢰성에 대해 보증하지 않습니다. 제3자 콘텐츠 및 링크에 대해 책임지지 않습니다.
            </p>

            <h2>10. 책임 제한</h2>
            <p>
              법이 허용하는 범위 내에서, 당사는 서비스 이용으로 인한 간접적, 우발적, 특별, 결과적 손해에 대해 책임지지 않습니다.
            </p>

            <h2>11. 서비스 변경 및 종료</h2>
            <p>
              당사는 언제든지 서비스를 수정, 중단 또는 종료할 수 있습니다. 중요한 변경 사항은 사전에 공지합니다.
            </p>

            <h2>12. 준거법</h2>
            <p>
              본 약관은 대한민국 법률에 따라 해석되며, 분쟁은 대한민국 법원의 관할에 따릅니다.
            </p>

            <h2>13. 문의</h2>
            <p>
              약관에 관한 문의는 <Link to="/contact">문의 양식</Link>을 통해 연락해 주세요.
            </p>
          </>
        ) : (
          <>
            <h2>1. Agreement to Terms</h2>
            <p>
              By accessing or using KoreanHub.net ("Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, you may not use the Service.
            </p>

            <h2>2. Description of Service</h2>
            <p>
              KoreanHub is a community platform for Koreans living abroad, providing:
            </p>
            <ul>
              <li>Community forums and discussions</li>
              <li>Korean business directory</li>
              <li>Accommodation booking services</li>
              <li>Immigration and visa information</li>
              <li>Events and deals information</li>
            </ul>

            <h2>3. Account Registration</h2>
            <p>You may need to create an account to use the Service. You agree to:</p>
            <ul>
              <li>Provide accurate information</li>
              <li>Maintain the security of your account</li>
              <li>Be responsible for all activities under your account</li>
              <li>Notify us immediately of any security breach</li>
            </ul>

            <h2>4. User Content</h2>
            <p>Regarding content you post:</p>
            <ul>
              <li>You retain ownership of your content</li>
              <li>You grant us a license to use, display, and distribute it</li>
              <li>You warrant that your content does not infringe others' rights</li>
              <li>We reserve the right to remove inappropriate content</li>
            </ul>

            <h2>5. Prohibited Activities</h2>
            <p>The following activities are prohibited:</p>
            <ul>
              <li>Posting illegal or harmful content</li>
              <li>Harassing or threatening others</li>
              <li>Spam or commercial advertising</li>
              <li>Unauthorized use of others' accounts</li>
              <li>Attempting to breach service security</li>
              <li>Intellectual property infringement</li>
              <li>Spreading false information</li>
            </ul>

            <h2>6. Accommodation Bookings</h2>
            <p>When using accommodation booking services:</p>
            <ul>
              <li>We are a platform connecting hosts and guests</li>
              <li>Hosts are responsible for listing accuracy and condition</li>
              <li>Payments are processed securely with cancellation policies</li>
              <li>We may mediate disputes between parties</li>
            </ul>

            <h2>7. Payments and Refunds</h2>
            <ul>
              <li>All payments are processed in the displayed currency</li>
              <li>Refunds are subject to each service's cancellation policy</li>
              <li>We reserve the right to cancel fraudulent transactions</li>
            </ul>

            <h2>8. Intellectual Property</h2>
            <p>
              All content, features, and design of the Service are our property and protected by copyright laws. You may not reproduce or distribute without express permission.
            </p>

            <h2>9. Disclaimer</h2>
            <p>
              The Service is provided "as is." We make no warranties regarding accuracy, completeness, or reliability. We are not responsible for third-party content or links.
            </p>

            <h2>10. Limitation of Liability</h2>
            <p>
              To the extent permitted by law, we are not liable for any indirect, incidental, special, or consequential damages arising from your use of the Service.
            </p>

            <h2>11. Service Changes and Termination</h2>
            <p>
              We may modify, suspend, or terminate the Service at any time. We will provide notice of significant changes in advance.
            </p>

            <h2>12. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the Republic of Korea. Disputes are subject to the jurisdiction of Korean courts.
            </p>

            <h2>13. Contact Us</h2>
            <p>
              For questions about these Terms, please reach us through our <Link to="/contact">contact form</Link>.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
